<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="4" md="4" class="chart-stats">
        <DoughnutChart
          class="elevation-1 chart-st"
          v-if="isStatsReady"
          :data="getStatsGenero.data"
          :labels="getStatsGenero.labels"
          :title="'Número de utilizadores por género'"
        />
      </v-col>
      <v-col cols="12" sm="5" md="5" class="chart-stats">
        <RadarChart
          class="elevation-1 chart-st"
          v-if="isStatsReady"
          :data="getStatsGS.data"
          :labels="getStatsGS.labels"
          :title="'Número de utilizadores por Grupo sanguíneo'"
          :label="'Grupo sanguíneo'"
          :step="1"
        />
      </v-col>
      <v-col cols="12" sm="3" md="3" class="chart-stats">
        <Birthdays
          class="elevation-1 chart-st"
          v-if="isStatsReady"
          :data="getAniversariosMesAtual"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6" class="chart-stats">
        <BarChart
          class="elevation-1 chart-st"
          v-if="isStatsReady"
          :data="getStatsNacionalidade.data"
          :labels="getStatsNacionalidade.labels"
          :title="'Número de utilizadores por país'"
          :label="'Nacionalidades'"
          :step="1"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6" class="chart-stats">
        <Calendar
          v-if="isStatsReady"
          :aniversarios="getAniversarios"
          :colheitas="getColheitasMesAtual"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6" class="chart-stats">
        <BarChart
          class="elevation-1 chart-st"
          v-if="isStatsReady"
          :data="getStatsBrigadasMes.data"
          :labels="getStatsBrigadasMes.labels"
          :title="'Número de brigadas por mês'"
          :label="'Brigadas'"
          :step="1"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6" class="chart-stats">
        <LineChart
          class="elevation-1 chart-st"
          v-if="isStatsReady"
          :data="getStatsDonativosMes.data"
          :labels="getStatsDonativosMes.labels"
          :title="'Valor total de donativos por mês'"
          :label="'Donativos'"
          :unidade="'€'"
        />
      </v-col>
      <v-col cols="12" sm="12" md="12" class="chart-stats">
        <LineChart
          class="elevation-1 chart-st"
          v-if="isStatsReady"
          :data="getStatsNumeroColheitasMes.data"
          :labels="getStatsNumeroColheitasMes.labels"
          :title="'Número de colheitas por mês'"
          :label="'Colheitas'"
          :step="1"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  components: {
    DoughnutChart: () => import("@/components/charts/Doughnut"),
    BarChart: () => import("@/components/charts/Bar"),
    LineChart: () => import("@/components/charts/Line"),
    RadarChart: () => import("@/components/charts/Radar"),
    Birthdays: () => import("@/components/cards/Birthdays"),
    Calendar: () => import("@/components/cards/Calendar")
  },
  computed: {
    getSession() {
      return this.$store.getters["session/getState"]
    },
    isStatsReady() {
      return this.$store.getters["stats/getStatus"]
    },
    getAniversariosMesAtual() {
      return [].concat(
        this.$store.getters["stats/getAll"]["aniversarios"].filter(el => {
          return (
            this.$moment(el.data).format("MM") == this.$moment().format("MM")
          )
        })
      )
    },
    getAniversarios() {
      return [].concat(
        this.$store.getters["stats/getAll"]["aniversarios"].map(el => {
          el.data = `${this.$moment().format("YYYY")}-${this.$moment(
            el.data
          ).format("MM-DD")}`
          return el
        })
      )
    },
    getStatsGenero() {
      var array = [].concat(this.$store.getters["stats/getAll"]["genero"])

      return {
        data: array.map(el => {
          return el.total
        }),
        labels: array.map(el => {
          return el.nome
        })
      }
    },
    getStatsGS() {
      var array = [].concat(this.$store.getters["stats/getAll"]["gs"])

      return {
        data: array.map(el => {
          return el.total
        }),
        labels: array.map(el => {
          return el.nome
        })
      }
    },
    getStatsNacionalidade() {
      var array = [].concat(
        this.$store.getters["stats/getAll"]["nacionalidade"]
      )

      return {
        data: array.map(el => {
          return el.total
        }),
        labels: array.map(el => {
          return el.nome.toUpperCase()
        })
      }
    },
    getStatsBrigadasMes() {
      var array = [].concat(this.$store.getters["stats/getAll"]["brigadas_mes"])

      return {
        data: array.map(el => {
          return el.total
        }),
        labels: array.map(el => {
          return this.$moment(el.data)
            .format("MMM")
            .toUpperCase()
        })
      }
    },
    getStatsNumeroColheitasMes() {
      var array = [].concat(
        this.$store.getters["stats/getAll"]["numero_colheitas_mes"]
      )

      return {
        data: array.map(el => {
          return el.total
        }),
        labels: array.map(el => {
          return this.$moment(el.data)
            .format("MMM")
            .toUpperCase()
        })
      }
    },
    getColheitasMesAtual() {
      return [].concat(this.$store.getters["stats/getAll"]["colheitas_mes"])
    },
    getStatsDonativosMes() {
      var array = [].concat(
        this.$store.getters["stats/getAll"]["donativos_mes"]
      )

      return {
        data: array.map(el => {
          return el.total
        }),
        labels: array.map(el => {
          return this.$moment(el.data)
            .format("MMM")
            .toUpperCase()
        })
      }
    }
  },
  data: () => ({})
}
</script>
<style scoped>
.chart-stats {
  padding: 1% !important;
}

.chart-st {
  padding: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  height: 100%;
  max-height: 40vh;
}
</style>
